const isDebugLogsEnabled = () => String(process.env.REACT_APP_DEBUG_LOGS || 'false').toLowerCase() === 'true';

export const debugLog = (...args) => {
  if (isDebugLogsEnabled()) {
    console.log(...args);
  }
};

export const debugWarn = (...args) => {
  if (isDebugLogsEnabled()) {
    console.warn(...args);
  }
};

const debugLogger = {
  debugLog,
  debugWarn
};

export default debugLogger;
